import { del, get, set } from 'idb-keyval';

/**
 * Small JSON values (editor state, presets, preferences) live in localStorage;
 * the uploaded image is a multi-megabyte blob, so it goes to IndexedDB where it
 * will not blow the ~5 MB localStorage quota.
 */
export function loadJSON<T>(key: string): T | null {
  if (typeof localStorage === 'undefined') return null;
  try {
    const raw = localStorage.getItem(key);
    return raw === null ? null : (JSON.parse(raw) as T);
  } catch {
    return null;
  }
}

export function saveJSON(key: string, value: unknown): void {
  if (typeof localStorage === 'undefined') return;
  try {
    localStorage.setItem(key, JSON.stringify(value));
  } catch {
    // Quota exceeded or storage disabled (private mode) — autosave is best effort.
  }
}

export function removeJSON(key: string): void {
  if (typeof localStorage === 'undefined') return;
  try {
    localStorage.removeItem(key);
  } catch {
    /* ignore */
  }
}

const IMAGE_KEY = 'thumbnail-generator:image:v1';

export async function saveImageBlob(blob: Blob): Promise<void> {
  try {
    await set(IMAGE_KEY, blob);
  } catch {
    /* ignore */
  }
}

export async function loadImageBlob(): Promise<Blob | null> {
  try {
    return (await get<Blob>(IMAGE_KEY)) ?? null;
  } catch {
    return null;
  }
}

export async function clearImageBlob(): Promise<void> {
  try {
    await del(IMAGE_KEY);
  } catch {
    /* ignore */
  }
}
